








import FormField from '@/components/FormField'

export default {
    name: 'Checkbox'

    extends: FormField
}
